"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODALS_CONF = exports.useFilterMapping = exports.filterGroupDefinitions = exports.getBillingStatus = void 0;
var end2end_1 = require("@hudled/end2end");
var get_1 = __importDefault(require("lodash/fp/get"));
var filter_1 = require("utils/filter");
var constants_1 = require("../constants");
var EnableCustomerModal_1 = __importDefault(require("./Modals/EnableCustomer/EnableCustomerModal"));
var getBillingStatus = function (item) { return item.agreementStatus === 'cancelled' ? 'cancelled'
    : item.inactiveSince ? 'inactive' // Right now that'd usually mean that it isArchived. The other case of Inactive is cancelled
        : item.agreementStatus === 'sent' ? 'sent'
            : item.lastPaymentFailedOn ? 'paymentAttemptFailed'
                : item.madeFirstPayment ? 'recharging'
                    : item.initiatedFirstPayment ? 'processingFirstPayment'
                        : item.agreementStatus === 'accepted' ? 'agreementAccepted'
                            : item.isRechargeEnabled ? 'scheduled'
                                : 'new'; };
exports.getBillingStatus = getBillingStatus;
var taxTypeDef = (0, filter_1.makeGroupDef)('Tax Type', function (customer) { return customer.isTaxExcluded ? 'Zero' : 'GST'; });
var statusGroupDef = (0, filter_1.makeGroupDef)('Status', function (item) { var _a; return (_a = constants_1.RECHARGE_STATUS_MAPPER[(0, exports.getBillingStatus)(item)].text) !== null && _a !== void 0 ? _a : 'Empty'; });
exports.filterGroupDefinitions = [taxTypeDef, statusGroupDef];
exports.useFilterMapping = (0, filter_1.makeUseFilterItems)([
    (0, get_1.default)('name'),
    function (item) { return ((item === null || item === void 0 ? void 0 : item.startDate) && (item === null || item === void 0 ? void 0 : item.endDate)) && (0, end2end_1.getDateRange)(item.startDate, item.endDate); },
    function (item) { return "".concat(item.listPrice); },
    function (item) { return "".concat(item.clientPrice); },
    function (item) { return (0, end2end_1.formatPercentagePrecise)(item.clientDiscount); },
    function (item) { return constants_1.RECHARGE_STATUS_MAPPER[(0, exports.getBillingStatus)(item)].text; },
], exports.filterGroupDefinitions);
exports.MODALS_CONF = {
    enable_billing: EnableCustomerModal_1.default,
};
